<template>
  <component-wrapper class="contact-tiles-fi">
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12">
        <richtext-fi
          class="contact-tiles-fi__text"
          field-name="text"
        />

        <div class="contact-tiles-fi__contact-tiles">
          <multi-data-source-provider-fi field-name="contactTiles">
            <contact-tile-fi />
          </multi-data-source-provider-fi>
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script setup lang="ts">
import { MultiDataSourceProviderFi, RichtextFi } from 'atoms';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import ContactTileFi from '@/components/contact-tile-fi/ContactTileFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';

defineOptions({ name: 'ContactTilesFi' });
</script>

<style scoped src="./contact-tiles-fi" />
